"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useParams = exports.ParamsContext = void 0;

var _react = require("react");

var _internal = require("./internal");

const ParamsContext = (0, _internal.createNamedContext)('Params', {});
exports.ParamsContext = ParamsContext;

const useParams = () => {
  const params = (0, _react.useContext)(ParamsContext);
  return params;
};

exports.useParams = useParams;